import { createContext, useContext, useState } from 'react';
import { getUnapprovedAgencyCount } from 'src/services/admin/agencyAuthority';

interface AgencyCountContextType {
  unapprovedCount: number;
  fetchUnapprovedCount: () => Promise<void>;
  isLoading: boolean;
}

export const AgencyCountContext = createContext<AgencyCountContextType>({
  unapprovedCount: 0,
  fetchUnapprovedCount: async () => {},
  isLoading: false
});

const AgencyCountProvider = (props: { children: React.ReactNode }) => {
  const [unapprovedCount, setUnapprovedCount] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchUnapprovedCount = async () => {
    try {
      setIsLoading(true);
      const response = await getUnapprovedAgencyCount();
      if (
        response &&
        response.code === 'SUCCESS' &&
        response.data !== undefined
      ) {
        setUnapprovedCount(response.data);
      }
    } catch (error) {
      console.error('Error fetching unapproved agency count:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AgencyCountContext.Provider
      value={{
        unapprovedCount,
        fetchUnapprovedCount,
        isLoading
      }}
      {...props}
    />
  );
};

export default AgencyCountProvider;

export const useAgencyCount = () => useContext(AgencyCountContext);
